import { DatePickerRoot } from "./DatePicker";
import { DatePickerTrigger } from "./DatePickerTrigger";
import { DatePickerCalendar } from "./DatePickerCalendar";
import { DatePickerPresets } from "./DatePickerPresets";
import { DatePickerActions } from "./DatePickerActions";

export const DatePicker = Object.assign(DatePickerRoot, {
  Trigger: DatePickerTrigger,
  Calendar: DatePickerCalendar,
  Presets: DatePickerPresets,
  Actions: DatePickerActions,
});

export { useDatePickerContext } from "./DatePickerContext";

export type {
  DatePickerProps,
  DatePickerTriggerProps,
  DatePickerTriggerVariant,
  DatePickerCalendarProps,
  DatePickerPresetsProps,
  DatePickerActionsProps,
  DatePickerContextValue,
  DatePreset,
} from "./types";

export { formatDateSmart } from "./formatDateSmart";
